import React, { useState, useRef } from 'react';
import {
    createStyles,
    makeStyles,
    Theme,
} from '@material-ui/core';

import {
    List,
    ListCell,
    ListContainer,
    ListHeader,
    ListItem,
} from '../../../components/List';
import { Detail, File } from '../../../data/Repair';
import { useWindowResizeEffect } from '../../../units/useWindowResizeEffect';
import { Button } from '../../../components/Button';
import { pathToDownloadURL } from '../../../api/files';

type DownloadListProps = {
    fileList: File[],
    onItemClick?: (item: File) => void,
    listRef?: React.RefObject<HTMLDivElement>,
};

DownloadList.defaultProps = {
    onItemClick: () => {},
    listRef: null,
};

const useStyles = makeStyles((theme: Theme) => createStyles({
    root: {
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        '& .MuiTableCell-stickyHeader': {
            backgroundColor: theme.palette.background.paper,
        },
    },
    container: {
        height: '100%',
    },
    downloadButton: {
        padding: 0,
        '& a': {
            width: '100%',
            padding: '4px 8px',
            color: theme.palette.common.white,
            textDecoration: 'none',
        },
    },
}));

function DownloadList(props: DownloadListProps): React.ReactElement {
    const {
        fileList,
        onItemClick = DownloadList.defaultProps.onItemClick,
        listRef,
    } = props;
    const classes = useStyles();

    const rootEl = useRef<HTMLDivElement>(null);
    const [containerHeight, setContainerHeight] = useState('100%');

    useWindowResizeEffect(() => {
        if (rootEl && rootEl.current) {
            // setContainerHeight(`${rootEl.current.clientHeight - 56}px`);
        }
    }, [rootEl]);

    return (
        <div className={classes.root}>
            <ListContainer className={classes.container} containerRef={rootEl}>
                <ListHeader>
                    <ListCell width={200}>檔案名稱</ListCell>
                    <ListCell width={160}>操作</ListCell>
                </ListHeader>
                <List containerHeight={containerHeight} containerRef={listRef}>
                    {fileList.map((item) => (
                        <ListItem onClick={() => onItemClick(item)}>
                            <ListCell width={200}>{item.name}</ListCell>
                            <ListCell width={160}>
                                <Button className={classes.downloadButton} size="small">
                                    <a target="_blank" href={pathToDownloadURL(`${item.file_path}?openExternalBrowser=1`)} rel="noreferrer">閱覽</a>
                                </Button>
                            </ListCell>
                        </ListItem>
                    ))}
                </List>
            </ListContainer>
        </div>
    );
}

export { DownloadList };
